import TokenService from "@/helpers/token";
import {userPositions} from "@/helpers/constants";

export function getContactAttribute() {
  const resultOrg = [
    {
      name: 'transactionTime',
      title: 'Thời gian',
      value: true,
      backgroundColor: "#FFFFE5",
    },
    {
      name: 'bankName',
      title: 'Ngân hàng',
      value: true,
      backgroundColor: "#FFFFE5",
    },
    {
      name: 'importingSource',
      title: 'Nguồn',
      value: true,
      backgroundColor: "#FFFFE5",
    },
    {
      name: 'messageContent',
      title: 'Nội dung tin nhắn',
      value: true,
      backgroundColor: "#FFFFE5",
    },
    {
      name: 'detail',
      title: 'Trích xuất',
      value: true,
      backgroundColor: "#FFFFE5",
    },
    {
      name: 'orderInfo',
      title: 'Thông tin đơn',
      value: true,
    },
    {
      name: 'saleName',
      title: 'Sale',
      value: true,
      alwayShow: true,
    },
    {
      name: 'approvedFeedback',
      title: 'Phản hồi người duyệt',
      value: true,
    },
    {
      name: 'transactionStatus',
      title: 'Trạng thái',
      value: true,
    },
  ];

  let storedData = localStorage.getItem('displayColumnsInOrderPaymentChecklist');
  let rowAttributesNotIn = [];
  if(storedData) {
    storedData = JSON.parse(storedData);
    let storedDataReturn = [];
    if(storedData && storedData.length){
      let isExist = {
        numberOfCall: false
      };
      for(let j = 0; j < resultOrg.length; j++){
        let item = resultOrg[j];
        for(let i = 0; i < storedData.length; i++){
          if(storedData[i].name == item.name){
            item.value = storedData[i].value;
          }
        }
        storedDataReturn.push(item);
      }
    }
    storedDataReturn = storedDataReturn.filter(item => !rowAttributesNotIn.includes(item.name));
    return storedDataReturn;
  }
  let resultOrgClone = resultOrg.filter(item => !rowAttributesNotIn.includes(item.name));
  return resultOrgClone;
  // return resultOrg;
}
